import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import BalanceCard from './Components/BalanceCard';
import AddressCard from './Components/AddressCard';
import CreateWalletFiel from './Components/CreateWalletFiel';
import { useQuery, } from 'react-query';
import { fetcher } from 'api/client';
import { noop, parseDate } from 'utils'
import { getEthereumBalance, getBlockchainTransactions, getWallets } from 'api/actions/users';
import ReactTable from 'components/Shared/ReactTable';
import { CardDeck, CardGroup } from 'reactstrap';
import TratoLoader from 'components/Shared/TratoLoader';

function WalletDetail({ data, blockchain, qr, address, isSuccess, isLoadingBalance }) {
    const { t } = useTranslation();

    const columns = useMemo(() => [
        {
            Header: t('blockchain.event'),
            accessor: row => t(`blockchain.${row.type}`),
            type: 'input'
        },
        {
            Header: t('blockchain.to'),
            accessor: 'properties.blockchainLog.hash',
            target: '_blank',
            type: 'link',
            href: `${process.env.REACT_APP_ETHERSCAN_URL}/tx/`
        },
        {
            Header: t('blockchain.currency'),
            accessor: 'properties.blockchainLog.currency',
            type: 'input',
        },
        {
            Header: t('blockchain.ammount'),
            accessor: 'properties.blockchainLog.amount',
            type: 'input',
        },
        {
            Header: t('blockchain.execution_date'),
            accessor: row => parseDate(row.eventDate, 'Pp'),
            type: 'input',
        }
    ], [t]);

    return <>
        {/* <h5><b><i className="fas fa-wallet"></i>{' '}Wallet</b></h5> */}
        <CardDeck>
            <BalanceCard
                backgroundColor="bg-primary"
                isLoadingBalance={isLoadingBalance}
                balance={data.walletBalance}
                send={blockchain?.reduce((acc, x) => (acc += Number(x.properties?.blockchainLog?.amount) || 0), 0)}
                received={data.received}
                currency="ETH"
            />
            <AddressCard
                backgroundColor="bg-secondary"
                QRCode={qr}
                address={address}
            />
        </CardDeck>

        <h5 className="mt-4"><b><i className="fas fa-exchange-alt"></i>{' '}{t('blockchain.transactionHistory')}</b></h5>

        {isSuccess &&
            <ReactTable
                className="reportTable"
                readOnly={true}
                columns={columns}
                data={blockchain}
                handleUpdate={noop}
                setnewData={noop}
                handleDelete={noop}
                handleCreate={noop}
                newData={{}}
                showCreate={false}
                setshowCreate={noop}
                key="contractTypeTable"
            />
        }
    </>

}

function WalletContainer() {

    const { data: wallets = {}, isLoading } = useQuery(['get-wallets'], () => fetcher(getWallets()));
    const { data = {}, isLoading: isLoadingBalance } = useQuery(['user-get-eth-balance'], () => fetcher(getEthereumBalance()), {
        enabled: !!wallets?.fielWallet?.address
    });

    const { data: blockchain = [], isSuccess } = useQuery(['user-blockchain-transactions'], () => fetcher(getBlockchainTransactions()), {
        enabled: !!wallets?.fielWallet?.address
    });

    if (isLoading) return <TratoLoader size="lg" />

    return (
        <div className="profile-security">
            {wallets?.fielWallet?.address ?
                <WalletDetail
                    data={data}
                    isLoadingBalance={isLoadingBalance}
                    blockchain={blockchain}
                    address={wallets.fielWallet.address}
                    qr={wallets.fielWallet.qr}
                    isSuccess={isSuccess}
                /> :
                <CreateWalletFiel />
            }
        </div>
    )
}

export default WalletContainer;